import PropTypes from 'prop-types';
import React from 'react';
import ShareLinkModal from './ShareLinkModal';

const ShareFileModal = ({ team, attachment, csrfToken, onClose }) => (
  <ShareLinkModal
    title="Share File"
    description="Anyone with the link can download this file."
    endpoint={`/teams/${team.id}/calendar_event_attachments/${attachment.id}`}
    resourceKey="calendar_event_attachment"
    csrfToken={csrfToken}
    onClose={onClose}
  />
);

ShareFileModal.propTypes = {
  team: PropTypes.object.isRequired,
  attachment: PropTypes.object.isRequired,
  csrfToken: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ShareFileModal;
